export default function qa() {
    $(document).ready(function() {
  $('.questions-answers ul li').on('click', function() {
      $(this).find('.question-answer-text').slideToggle(400);
      $(this).find('.question-answer').toggleClass("rotate");
  });
});

}